import(/* webpackMode: "eager" */ "/var/www/schedly/calcom/apps/web/app/global-error.tsx");
